<template>
  <div class="detalleTransbankCredito">
    <h5>Detalle Transbak (credito)</h5>
    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th>Documento</th>
        <th>Banco</th>
        <th>N° Operacion</th>
        <th>Valor</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in tbkCredito">
        <td>{{item.tipo}} - {{item.folio}}</td>
        <td>{{item.detalle_pago.tarjetaCredito.banco | importacion}}</td>
        <td>{{item.detalle_pago.tarjetaCredito.numero | importacion}}</td>
        <td>{{item.detalle_pago.tarjetaCredito.monto | currency}}</td>
      </tr>
      <tr>
        <td colspan="3" style="text-align: end; font-weight: bold">Total:</td>
        <td style="font-weight: bold;">{{total() | currency}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "detalleTransbankCredito",
    data() {
      return {
        transbankCredito: [],
      }
    },
    methods: {
      total() {
        let _total = 0
        this.tbkCredito.forEach(item => {
          _total += parseInt(item.detalle_pago.tarjetaCredito.monto)
        })
        this.$emit('totalCredito', _total)
        return _total
      }
    },
    computed: {
      boletas() {
        return this.$store.getters.boletas.filter(item => item.forma_pago.includes('credito'))
          .map(b => {
            return {...b, tipo: 'BE'}
          })
          .filter(item => parseInt(item.folio) > 157886)
      },
      facturas() {
        return this.$store.getters.facturas.filter(item => item.forma_pago.includes('credito'))
          .map(f => {
            return {...f, tipo: 'FE'}
          })
          .filter(item => parseInt(item.folio) > 60542)
      },
      encargos() {
        return this.$store.getters.encargos.filter(item => item.forma_pago.includes('credito'))
          .map(e => {
            return {...e, tipo: 'EN'}
          })
      },
      tbkCredito() {
        return [...this.boletas, ...this.facturas, ...this.encargos]
      }
    },
    filters: {
      importacion(text) {
        return text ? text : 'Importado'
      }
    }

  }
</script>

<style scoped>
  /*tr td{*/
  /*    font-size: 14px;*/
  /*}*/

</style>
